/**
 * NMI Collect.js inline field styles shared with POS payment dialog.
 * Keep in sync when changing PointOfSale.jsx payment fields.
 */
export const nmiCollectPosInlineStyleConfig = {
  variant: "inline",
  invalidCss: {
    color: "#B40E3E",
    backgroundColor: "#F7F8FA",
    borderColor: "#E5E7EB",
  },
  validCss: {
    color: "#14855F",
    backgroundColor: "#F7F8FA",
    borderColor: "#E5E7EB",
  },
  /* Must match PaymentGatewayFields.css host (.payment-field) height or the iframe shows gray bands (“double border”). */
  customCss: {
    border: "1px solid #E5E7EB",
    borderRadius: "8px",
    height: "44px",
    minHeight: "44px",
    padding: "8px 14px",
    outline: "none",
    fontSize: "15px",
    fontFamily: "inherit",
    boxShadow: "none",
    transition: "border-color 0.15s ease, background-color 0.15s ease",
    boxSizing: "border-box",
    color: "#4b5563",
    backgroundColor: "#F7F8FA",
  },
  placeholderCss: {
    color: "#9ca3af",
    backgroundColor: "#F7F8FA",
  },
  /* Click/focus: white field + blue border only (no second glow ring — that looked like double border). */
  focusCss: {
    backgroundColor: "#FFFFFF",
    "background-color": "#FFFFFF",
    border: "1px solid #2563EB",
    borderColor: "#2563EB",
    boxShadow: "none",
    outline: "none",
  },
  googleFont: "Poppins",
};
